import { render } from "./EmployeeBalance.vue?vue&type=template&id=eb81d632&scoped=true"
import script from "./EmployeeBalance.vue?vue&type=script&lang=js"
export * from "./EmployeeBalance.vue?vue&type=script&lang=js"

import "./EmployeeBalance.vue?vue&type=style&index=0&id=eb81d632&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb81d632"]])

export default __exports__